import { gql } from '@apollo/client'

export default gql(`
    mutation adminCreateUser( $email: String!, $password: String!, $details: UserDetailInput) {
        adminCreateUser(
            email: $email
            password: $password
            details: $details
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
